const uiSchema = () => ({
  address: {
    'ui:widget': 'textarea',
  },
  location: {
    'ui:field': 'location',
  },
});

export default uiSchema;
